export const TEXTS = {
  CLIENTS_HUB: {
    MAIN_TITLE: 'CLIENTS_HUB.MAIN_TITLE',
    NEW_ITEM_BUTTON: 'CLIENTS_HUB.NEW_ITEM_BUTTON',
    SEARCH_BAR_PLACEHOLDER: 'CLIENTS_HUB.SEARCH_BAR_PLACEHOLDER',
    CLIENTS_TABLE: {
      NAME_COLUMN: 'CLIENTS_HUB.CLIENTS_TABLE.NAME_COLUMN',
      EMAIL_COLUMN: 'CLIENTS_HUB.CLIENTS_TABLE.EMAIL_COLUMN',
      PHONE_COLUMN: 'CLIENTS_HUB.CLIENTS_TABLE.PHONE_COLUMN',
      ADDRESS_COLUMN: 'CLIENTS_HUB.CLIENTS_TABLE.ADDRESS_COLUMN',
      EMPTY_STATE: {
        TITLE: 'CLIENTS_HUB.CLIENTS_TABLE.EMPTY_STATE.TITLE',
        ADD_BUTTON: 'CLIENTS_HUB.CLIENTS_TABLE.EMPTY_STATE.ADD_BUTTON',
      },
    },
    ITEM_MENU: {
      EDIT_ITEM_BUTTON: 'CLIENTS_HUB.ITEM_MENU.EDIT_ITEM_BUTTON',
      DELETE_ITEM_BUTTON: 'CLIENTS_HUB.ITEM_MENU.DELETE_ITEM_BUTTON',
    },
    DELETE_POPUP: {
      TITLE: 'CLIENTS_HUB.DELETE_POPUP.TITLE',
      DESCRIPTION: 'CLIENTS_HUB.DELETE_POPUP.DESCRIPTION',
      CANCEL_BUTTON: 'CLIENTS_HUB.DELETE_POPUP.CANCEL_BUTTON',
      DELETE_BUTTON: 'CLIENTS_HUB.DELETE_POPUP.DELETE_BUTTON',
    },
  },
} as const;
